var map = {
	".": "5460",
	"./": "5460",
	"./index": "5460",
	"./index.js": "5460",
	"./user": "c4e3",
	"./user/": "c4e3",
	"./user/index": "c4e3",
	"./user/index.js": "c4e3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "25a1a";